export default __webpack_public_path__ + "static/media/mail.85c43cc3.svg";